export interface BankTransferDetailsPublic {
  iban: string
  bic: string
  beneficiaryName: string
}

export interface PaymentMethodsPublicConfig {
  netopia: boolean
  stripe: boolean
  euplatesc: boolean
  payu: boolean
  cash_on_delivery: boolean
  bank_transfer: boolean
  bank_transfer_details: BankTransferDetailsPublic | null
  tbi: boolean
  tbi_default_instalments: string | null
}

export function parsePaymentMethodsPublicConfig(raw?: string): PaymentMethodsPublicConfig {
  if (!raw) {
    return {
      netopia: true,
      stripe: false,
      euplatesc: false,
      payu: false,
      cash_on_delivery: true,
      bank_transfer: false,
      bank_transfer_details: null,
      tbi: false,
      tbi_default_instalments: null,
    }
  }

  try {
    const parsed = JSON.parse(raw) as Partial<PaymentMethodsPublicConfig>
    const details = parsed.bank_transfer_details
    const hasDetails = Boolean(
      details
      && typeof details.iban === 'string'
      && details.iban.trim()
      && typeof details.beneficiaryName === 'string'
      && details.beneficiaryName.trim(),
    )

    return {
      netopia: parsed.netopia !== false,
      stripe: Boolean(parsed.stripe),
      euplatesc: Boolean(parsed.euplatesc),
      payu: Boolean(parsed.payu),
      cash_on_delivery: parsed.cash_on_delivery !== false,
      bank_transfer: Boolean(parsed.bank_transfer) && hasDetails,
      bank_transfer_details: hasDetails
        ? {
            iban: String(details!.iban).trim(),
            bic: String(details!.bic || '').trim(),
            beneficiaryName: String(details!.beneficiaryName).trim(),
          }
        : null,
      tbi: Boolean(parsed.tbi),
      tbi_default_instalments: parsed.tbi_default_instalments
        ? String(parsed.tbi_default_instalments)
        : null,
    }
  } catch {
    return {
      netopia: true,
      stripe: false,
      euplatesc: false,
      payu: false,
      cash_on_delivery: true,
      bank_transfer: false,
      bank_transfer_details: null,
      tbi: false,
      tbi_default_instalments: null,
    }
  }
}
